// import Button from 'components/Button'
import MFDAnnouncementBanner from 'components/Collectives/Common/MFDAnnouncementBanner'
import GenericLayout from 'components/GenericLayout'
import TeamMember from 'components/Team/TeamMember'

function TeamPage() {
  return (
    <>
      <MFDAnnouncementBanner />
      <GenericLayout bgColor="white">
        <div className="space-y-20 pb-32">
          <div className="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 text-center tracking-tight">
              Meet the Team
            </h2>
            <p className="mx-auto text-xl font-light text-gray-500 w-2/3 sm:w-full md:w-3/4 lg:w-2/3 text-center">
              We believe that building great technology for a diverse community
              is best done with a diverse team.
            </p>
          </div>

          <div className="flex flex-row items-center justify-center">
            <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-10 gap-y-10 md:gap-y-0">
              <TeamMember
                name="Alex Taub"
                role={`Co-Founder`}
                avatar="/static/team/alext.jpg"
                avatarPosition={'50% 25%'}
                upstream={'rxbeleRbuG'}
                twitter={`https://twitter.com/ajt`}
                linkedIn={`https://www.linkedin.com/in/alexandertaub/`}
                instagram={'https://www.instagram.com/ataub24/'}
                zed={'https://zed.run/stable/ajt'}
              />

              <TeamMember
                name="Michael Schonfeld"
                role={`Co-Founder`}
                avatar="/static/team/michael.jpg"
                upstream={'1i6161FnZ5'}
                twitter={`https://twitter.com/baconseason`}
                linkedIn={`https://www.linkedin.com/in/schonfeldmichael`}
                instagram={'https://www.instagram.com/baconseason'}
              />

              <TeamMember
                name="Sarah Wood"
                role={`COO`}
                avatar="/static/team/sarah.jpg"
                upstream={'ijyEoI_T-y'}
                twitter={`https://twitter.com/sarah___wood`}
                linkedIn={`https://www.linkedin.com/in/sarahwood313`}
                website={'https://www.joysoldier.com'}
              />

              <TeamMember
                name="Zhanna Schonfeld"
                role={`Head of Product Design`}
                avatar="/static/team/zhanna.jpg"
                avatarPosition={'50% 0%'}
                upstream={'twmZwAzTZ4'}
                linkedIn={`https://www.linkedin.com/in/zhannaschonfeld`}
                twitter={'https://twitter.com/zhannabanana'}
              />

              <TeamMember
                name="Kazi Islam"
                role={`Product Manager`}
                avatar="/static/team/kazi.jpg"
                avatarPosition={'68% 50%'}
                upstream={'_EA9vdnRIe'}
                linkedIn={`https://www.linkedin.com/in/kislam48`}
                twitter={`https://twitter.com/kislam48`}
                instagram={`https://www.instagram.com/kazi48`}
              />

              <TeamMember
                name={`Monica Rojas`}
                role={`Head of Community`}
                avatar="/static/team/monica_rojas.jpeg"
                upstream={'k6IHgF1uSB'}
                linkedIn={'https://www.linkedin.com/in/monica-rojas24/'}
                twitter={'https://twitter.com/LaMoniRojas'}
              />

              <TeamMember
                name={`Karandeep Singh`}
                role={`Senior Software Engineer`}
                avatar="/static/team/karandeep.png"
                upstream={'t8JrZhL-ws'}
                website={'https://github.com/kdsbatra'}
                linkedIn={'https://linkedin.com/in/karandeep1990'}
              />

              <TeamMember
                name="Mags Sawicka"
                role={`Senior Product Manager`}
                avatar="/static/team/mags.jpg"
                avatarPosition={'50% 0'}
                linkedIn={'https://www.linkedin.com/in/msawicka'}
              />

              <TeamMember
                name={`Jacky Sun`}
                role={`Head of Special Projects`}
                avatar="/static/team/jacky.jpg"
                upstream={'4aOPZbfHur'}
                twitter={'https://twitter.com/JSunDerulo'}
                linkedIn={'https://www.linkedin.com/in/jackysun98'}
              />

              {/* <div className="flex justify-center items-center">
            <Button label={'Join the Team'} size={'lg'} />
          </div> */}
            </ul>
          </div>
        </div>
      </GenericLayout>
    </>
  )
}

export default TeamPage
